import gql from "graphql-tag";

const GET_STORIES = gql`
  query Story(
    $languageCode: String!
    $app: App!
    $fromWeek: Int
    $toWeek: Int
    $hiddenFromDashboard: Boolean
    $shownRandomly: Boolean
    $orderBy: OrderBy
    $cursor: String
    $limit: Int
  ) {
    stories(
      filter: {
        languageCode: $languageCode
        app: $app
        fromWeek: $fromWeek
        toWeek: $toWeek
        hiddenFromDashboard: $hiddenFromDashboard
        shownRandomly: $shownRandomly
      }
      pagination: { orderBy: $orderBy, cursor: $cursor, limit: $limit }
    ) {
      edges {
        id
        title
        subtitle
        color
        icon {
          name
          base64
          mimetype
        }
        availability {
          published
        }
        meta {
          displayOrder
        }
        storySections {
          id
          title
          subtitle
          availability {
            published
          }
          meta {
            displayOrder
          }
          subStorySections {
            id
            title
            subtitle
            content
            tags
            meta {
              displayOrder
            }
            availability {
              published
              fromWeek
              toWeek
              hiddenFromDashboard
              shownRandomly
              isBorn
            }
          }
        }
      }
      pageInfo {
        endCursor
        totalPages
        page
        hasPrevPage
        hasNextPage
        prevPage
        nextPage
        totalDocs
      }
    }
  }
`;

const DELETE_STORYARTICLE = gql`
  mutation DeleteStoryArticle($id: ID!) {
    deleteStoryArticle(id: $id)
  }
`;

const CREATE_STORYARTICLE = gql`
  mutation CreateStoryArticle(
    $title: String!
    $languageCode: String!
    $app: App!
    $published: Boolean
    $displayOrder: Int
  ) {
    createStoryArticle(
      availability: {
        languageCode: $languageCode
        app: $app
        published: $published
      }
      title: $title
      displayOrder: $displayOrder
    ) {
      id
    }
  }
`;

const UPDATE_STORYARTICLE = gql`
  mutation UpdateStoryArticle(
    $id: ID!
    $title: String
    $subtitle: String
    $color: String
    $displayOrder: Int
    $icon: ID
    $app: App!
    $languageCode: String!
    $published: Boolean
  ) {
    updateStoryArticle(
      id: $id
      title: $title
      subtitle: $subtitle
      color: $color
      displayOrder: $displayOrder
      icon: $icon
      availability: {
        app: $app
        published: $published
        languageCode: $languageCode
      }
    ) {
      id
    }
  }
`;

const CREATE_STORYSECTION = gql`
  mutation CreateStorySection(
    $storyArticleId: ID!
    $title: String!
    $subtitle: String
    $languageCode: String!
    $app: App!
    $published: Boolean
    $displayOrder: Int
  ) {
    createStorySection(
      storyArticleId: $storyArticleId
      title: $title
      subtitle: $subtitle
      displayOrder: $displayOrder
      availability: {
        languageCode: $languageCode
        app: $app
        published: $published
      }
    ) {
      id
    }
  }
`;

const DELETE_STORYSECTION = gql`
  mutation DeleteStorySection($id: ID!) {
    deleteStorySection(id: $id)
  }
`;

const UPDATE_STORYSECTION = gql`
  mutation UpdateStorySection(
    $id: ID!
    $title: String
    $subtitle: String
    $displayOrder: Int
    $languageCode: String!
    $app: App!
    $published: Boolean
  ) {
    updateStorySection(
      id: $id
      title: $title
      subtitle: $subtitle
      displayOrder: $displayOrder
      availability: {
        languageCode: $languageCode
        published: $published
        app: $app
      }
    ) {
      id
    }
  }
`;

const CREATE_SUBSTORYSECTION = gql`
  mutation CreateSubStorySection(
    $storySectionId: ID!
    $title: String!
    $subtitle: String
    $languageCode: String!
    $app: App!
    $published: Boolean
    $content: JSON
    $hiddenFromDashboard: Boolean
    $shownRandomly: Boolean
    $displayOrder: Int
  ) {
    createSubStorySection(
      storySectionId: $storySectionId
      title: $title
      subtitle: $subtitle
      content: $content
      displayOrder: $displayOrder
      availability: {
        languageCode: $languageCode
        app: $app
        published: $published
        hiddenFromDashboard: $hiddenFromDashboard
        shownRandomly: $shownRandomly
      }
    ) {
      id
    }
  }
`;

const DELETE_SUBSTORYSECTION = gql`
  mutation DeleteSubStorySection($id: ID!) {
    deleteSubStorySection(id: $id)
  }
`;

const UPDATE_SUBSTORYSECTION = gql`
  mutation UpdateSubStorySection(
    $id: ID!
    $title: String
    $subtitle: String
    $content: JSON
    $displayOrder: Int
    $languageCode: String!
    $app: App!
    $published: Boolean!
    $fromWeek: Int
    $toWeek: Int
    $hiddenFromDashboard: Boolean
    $shownRandomly: Boolean
    $tags: [String!]
    $isBorn: Boolean
  ) {
    updateSubStorySection(
      id: $id
      title: $title
      subtitle: $subtitle
      content: $content
      displayOrder: $displayOrder
      tags: $tags
      availability: {
        languageCode: $languageCode
        app: $app
        published: $published
        fromWeek: $fromWeek
        toWeek: $toWeek
        hiddenFromDashboard: $hiddenFromDashboard
        shownRandomly: $shownRandomly
        isBorn: $isBorn
      }
    ) {
      id
    }
  }
`;

const EXPORT_STORY = gql`
  mutation ExportStoryToCSV(
    $languageCode: String!
    $app: App!
    $published: Boolean
  ) {
    exportStoryToCSV(
      filter: { languageCode: $languageCode, published: $published, app: $app }
    )
  }
`;

export {
  CREATE_STORYARTICLE,
  CREATE_STORYSECTION,
  CREATE_SUBSTORYSECTION,
  DELETE_STORYARTICLE,
  DELETE_STORYSECTION,
  DELETE_SUBSTORYSECTION,
  EXPORT_STORY,
  GET_STORIES,
  UPDATE_STORYARTICLE,
  UPDATE_STORYSECTION,
  UPDATE_SUBSTORYSECTION,
};
